import { LegalPersonalityEnum, LegalPersonalityIdEnum } from 'src/app/domain/enums/legal-personality.enum';
import { GlobalUtils } from 'src/app/shared/global-utils';

export class FormDataCreate {
  public async build(element: any): Promise<FormData> {
    let {
      image,
      type,
      name,
      dueDate,
    } = element;

    let formData = new FormData();

    if (image?.toLowerCase().indexOf(';base64') != -1)
      formData.append(
        'image',
        new File(
          [await GlobalUtils.blobImageFromBase64String(image)],
          image?.toLowerCase().indexOf('png') != -1
            ? `filename.png`
            : `filename.jpeg`
        )
      );

      formData.append('dueDate', dueDate);
      formData.append('name', name?.toUpperCase());
    formData.append('type',  type);
    

    return formData;
  }
}
